"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.withBreakpoints = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _BreakpointProvider = require("./BreakpointProvider");
const withBreakpoints = Component => {
  // eslint-disable-next-line react/display-name
  return props => {
    const breakpoints = (0, _BreakpointProvider.useBreakpoint)();
    return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
      breakpoints: breakpoints
    }, props));
  };
};
exports.withBreakpoints = withBreakpoints;